/**
 * True when the shell runs under browser automation (Playwright, Chromatic, etc.).
 * Those runners set {@link Navigator.webdriver}; hiding dev-only chrome keeps
 * e2e flows and visual snapshots stable.
 */
export function isAutomatedBrowser(): boolean {
  return typeof navigator !== "undefined" && navigator.webdriver === true;
}
